import * as _ from "lodash";
import { Components } from "formiojs";
import { ValidationPatterns } from "@bbwt/modules/validation";

const TextFieldComponent = Components.components.textfield;

export default class MiproPatientEmailField  extends TextFieldComponent  {

    static schema() {
        return TextFieldComponent.schema({
            type: "miproPatientEmailField",
            label: "Patient Email",
            key: "dbo.mipro.miproPatientEmail",
            placeholder: "Enter Patient Email", 
            disabled: false, 
            input: true,
            validate: {
                custom: `valid = (!input || !!input.match(/${ValidationPatterns.email}/)) ? true : "Invalid email address";`
            }
        });
    }

    init() {
        super.init();
    }

    static get builderInfo() {
        return {
            title: "Patient Email",
            group: "basic",
            icon: "envelope",
            weight: 70,
            schema: MiproPatientEmailField.schema(),            
        };
    }
}

Components.addComponent("miproPatientEmailField", MiproPatientEmailField);